<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container"><a id="page_vi"></a>
<img alt="Images" src="images/f0006-1.jpg"/>
<p class="capr"><span class="small1"><em class="italic">Chris Heisey</em></span></p>
</div>
<div class="img_container0">
<img alt="Images" src="images/img.jpg"/>
</div>
<p class="center"><span class="weblink"><a href="http://www.emergingcivilwar.com" target="_blank"><span class="underline">www.emergingcivilwar.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Front1.vue?11504ae8